import type { ReactNode } from 'react';

import { Box } from '../../../common/ui/Box';
import { Text } from '../../Text/Text';

interface ComboBoxDoubleLineOptionProps {
    title: ReactNode;
    description: ReactNode;
    leadingVisual?: ReactNode;
    titleSuffix?: ReactNode;
    trailingVisual?: ReactNode;
}

export const ComboBoxDoubleLineOption = ({
    title,
    description,
    leadingVisual,
    titleSuffix,
    trailingVisual,
}: ComboBoxDoubleLineOptionProps) => {
    return (
        <Box data-combo-box-double-line-option="" display="flex" alignItems="center" gap={8} height={56} minWidth={0}>
            {leadingVisual ? (
                <Box flexShrink={0} height={40} width={24}>
                    {leadingVisual}
                </Box>
            ) : null}
            <Box display="flex" flexDirection="column" flex={1} minWidth={0}>
                <Box display="flex" alignItems="center" justifyContent="space-between" gap={8} minWidth={0}>
                    <Box display="flex" alignItems="center" gap={4} minWidth={0}>
                        <Text variant="small" fontWeight={500} truncated style={{ flexShrink: 1 }}>
                            {title}
                        </Text>
                        {titleSuffix ? <Box flexShrink={0}>{titleSuffix}</Box> : null}
                    </Box>
                    {trailingVisual ? <Box flexShrink={0}>{trailingVisual}</Box> : null}
                </Box>
                <Text variant="extraSmall" color="foreground.muted" truncated>
                    {description}
                </Text>
            </Box>
        </Box>
    );
};
